import { SortOrder } from '../enums/sort-order.enum';

export interface ISort {
  key: string;
  order: SortOrder;
}
